import React from "react";
import PropTypes from "prop-types";

import {
	Icones,
	ContainerCard,
	ContainerText,
	TituloCard,
	ContainerImagem,
	TituloItem,
	DescricaoItem,
	ObservacaoItem,
	ContainerItem,
	SpacerItem
} from "./styles";
import { ContainerDivider } from "../../layouts/Default";
import ReactMarkdown from "react-markdown";

export default function CardTabela(props) {
	const { card } = props;
	const linhaTabela = card.linhasDaTabelaCollection.items;
	return (
		<>
			<ContainerCard usarBorda={card.usarBorda} alinhamento={card.alinhamento}>
				{card.titulo && <TituloCard> {card.titulo} </TituloCard>}
				{card.imagem && (
					<ContainerImagem
						src={card.imagem.url}
						alt={card.imagem.description}
						title={card.imagem.title}
					/>
				)}
				<ContainerText>
					{linhaTabela.map((item, index) => {
						return (
							<React.Fragment key={index}>
								<ContainerItem size={item.size}>
									{item.iconesCollection &&
										item.iconesCollection.items.length > 0 && (
											<Icones>
												{item.iconesCollection.items.map(icone => (
													<img
														src={icone.url}
														alt={icone.description}
														key={icone.title}
													/>
												))}
											</Icones>
										)}
									{item.titulo && (
										<TituloItem blur={item.blur}>{item.titulo}</TituloItem>
									)}
									{item.descricao && (
										<DescricaoItem
											blur={item.blur}
											subtitle={item.titulo ? true : false}
										>
											{item.descricao}
										</DescricaoItem>
									)}
									{item.observacao && (
										<ObservacaoItem blur={item.blur}>
											<ReactMarkdown>{item.observacao}</ReactMarkdown>
										</ObservacaoItem>
									)}
									{index < linhaTabela.length - 1}
								</ContainerItem>
								{index < linhaTabela.length - 1 && <ContainerDivider />}
							</React.Fragment>
						);
					})}
					<SpacerItem />

					{/* {card.regulamento && (
						<CheckboxContainer blur={card.regulamento.blur}>
							<Checkbox onChange={card.regulamento.onChange} />
							<span>
								Estou ciente que, ao prosseguir, aceito os{" "}
								<span className="underline" onClick={card.regulamento.show}>
									termos e condições
								</span>{" "}
								da campanha
							</span>
						</CheckboxContainer>
					)}

					{props.n_buttons > 0 && (
						<>
							<ContainerCTA n_buttons={props.n_buttons}>
								{card.botao && (
									<div>
										<BotaoCTA botao={card.botao} />
									</div>
								)}

								{card.botaoExtra && (
									<>
										<SpacerItem />
										<div>
											<BotaoCTA botao={card.botaoExtra} />
										</div>
									</>
								)}
							</ContainerCTA>

							{card.link && (
								<CardLink blur={card.link.blur}>
									<a href={card.link.rota.endereco} onClick={card.link.onClick}>
										<LinkDS>{card.link.label}</LinkDS>
									</a>
								</CardLink>
							)}
						</>
					)} */}
				</ContainerText>
			</ContainerCard>
		</>
	);
}

CardTabela.propTypes = {
	card: PropTypes.object
};
